import React, { useEffect, useState } from "react";
import TopNav from "@/components/TopNav";
import { api } from "@/lib/api";
import { LEADERBOARD } from "@/constants/testIds";

const RANK_ACCENTS = ["#FFD600", "#C0C0C0", "#CD7F32"];

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/leaderboard");
        setRows(r.data);
      } catch (e) {}
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen" data-testid={LEADERBOARD.container}>
      <TopNav/>
      <main className="max-w-4xl mx-auto px-6 sm:px-10 py-10 relative z-10">
        <div className="mb-8">
          <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-2">Highscores</div>
          <h1 className="font-display text-4xl tracking-tighter">Hall of shame.</h1>
        </div>
        <div className="rounded-2xl bg-[#161324] border border-white/5 overflow-hidden">
          <div className="grid grid-cols-12 px-6 py-3 text-[10px] uppercase tracking-[0.2em] text-white/40 border-b border-white/5">
            <div className="col-span-1">#</div>
            <div className="col-span-5">Player</div>
            <div className="col-span-2 text-right">Wins</div>
            <div className="col-span-2 text-right">Games</div>
            <div className="col-span-2 text-right">Score</div>
          </div>
          {loading && <div className="p-6 text-white/50">Loading…</div>}
          {!loading && rows.length === 0 && <div className="p-6 text-white/50">No games played yet. Be the first!</div>}
          {rows.map((u, i) => (
            <div key={u.user_id} className="grid grid-cols-12 px-6 py-3 items-center border-b border-white/5 last:border-b-0 hover:bg-white/5 transition-colors">
              <div className="col-span-1 font-display" style={{color: RANK_ACCENTS[i] || "#FFFFFF"}}>{i+1}</div>
              <div className="col-span-5 flex items-center gap-3">
                <img src={u.avatar || u.picture} alt="" className="w-9 h-9 rounded-full border border-white/10"/>
                <div className="font-semibold">{u.name}</div>
              </div>
              <div className="col-span-2 text-right font-display text-lg">{u.wins || 0}</div>
              <div className="col-span-2 text-right text-white/70">{u.games_played || 0}</div>
              <div className="col-span-2 text-right font-display text-lg" style={{color:"var(--uno-yellow)"}}>{u.score || 0}</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
